export const SIDEBAR_ADD_TO_BAG_QUANTITY = 1;
